import './NotesApp.css';
import { useState } from "react";
import { FaRegTimesCircle } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { supabase } from './supabase-client';
import { useEffect } from 'react';
import { useRef } from 'react';

function NotesApp({session}) {

  const [currentPage, setCurrentPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState([]);

  const [noteDescription, setNoteDescription] = useState("");
  const [pageTitle, setPageTitle] = useState("Home");

  const [isNewNote, setNewNote] = useState(false);

  const [newTask, setNewTask] = useState({ title: "Note", description: "" });
  const debounceId = useRef(null);

  const [isDeleteNote, setDeleteNote] = useState(false);

  const [currentNote, setCurrentNote] = useState();
  const [currentIndex, setCurrentIndex] = useState();

  const UpdateWorspace = (e, index) => {
    if (e != null) {
      e.preventDefault();
    }

    if (index > notes.length) {
      console.error("The Note DOES NOT EXIST");
      return;
    }

    if (notes.length >= currentPage && currentPage > 0) {
      updateNote(notes[currentPage - 1].id, currentPage);
    }

    if (currentPage == index) {
      return;
    }

    setCurrentPage(index);

    if (index != 0) {
      setNoteDescription(notes[index - 1]["description"]);
      setPageTitle(notes[index - 1]["title"]);
      setNewTask({ title: notes[index - 1]["title"], description: notes[index - 1]["description"] })
    } else {
      setPageTitle("Home");
      setNewTask({ title: "Home", description: ""})
    }
  }

  const fetchNotes = async () => {
    const { error, data } = await supabase.from("notes").select("*").order("created_at", { ascending: true });

    if (error) {
      console.error("ERROR READING NOTE", error.message);
      return;
    }

    setNotes(data);
  }

  const addNote = async (e) => {
    e.preventDefault();

    const { error } = await supabase.from("notes").insert({ title: "Note", description: "", email: session.user.email}).single();
    if (error) {
      console.error("ERROR ADDING NOTE", error.message);
      return;
    }
    fetchNotes();
    setNewNote(true);
  };

  const deleteNote = async (id, index) => {
    const { error } = await supabase.from("notes").delete().eq("id", id);
    if (error) {
      console.error("ERROR REMOVING NOTE", error.message);
      return;
    }

    if (index == currentPage) {
      UpdateWorspace(null, 0);
    } else if (index < currentPage) {
      setCurrentPage(currentPage - 1);
    } else {
      UpdateWorspace(null, currentPage);
    }

    fetchNotes();
  };

  const updateNote = async (id, index) => {
    if (notes[index - 1]["title"] != newTask.title) {
      const { error } = await supabase.from("notes").update({ title: newTask.title }).eq("id", id);
      if (error) {
        console.error("ERROR UPDATING NOTE", error.message);
        return;
      }
    }

    if (notes[index - 1]["description"] != newTask.description) {
      const { error } = await supabase.from("notes").update({ description: newTask.description }).eq("id", id);
      if (error) {
        console.error("ERROR UPDATING NOTE", error.message);
        return;
      }
    }

    fetchNotes();
  };
  
  const logOut = async () => {

    await supabase.auth.signOut();

   }

  const deletePopUp = (note,index) => {

    setCurrentNote(note);
    setCurrentIndex(index);
    setDeleteNote(true);

  }

  useEffect(() => {
    fetchNotes();
  }, []);

  useEffect(() => {
    if (isNewNote) {
      setNewNote(false);
      UpdateWorspace(null, notes.length);
    }
  }, [notes]);

  useEffect(() => {
    if (notes.length >= currentPage && currentPage > 0) {
      const flush = () => updateNote(notes[currentPage - 1].id, currentPage);
      window.addEventListener("beforeunload", flush);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") flush();
      });
      window.addEventListener("pagehide", flush);
      return () => {
        window.removeEventListener("beforeunload", flush);
        window.removeEventListener("pagehide", flush);
      };
    }
  }, [newTask]);

  useEffect(() => {
    if (currentPage != 0) {
      if (debounceId.current) window.clearTimeout(debounceId.current);

      debounceId.current = window.setTimeout(() => updateNote(notes[currentPage - 1].id, currentPage), 100);
      return () => {
        if (debounceId.current) window.clearTimeout(debounceId.current);
      };
    }
  }, [newTask]);

  return (
    <div className="App">

      {isDeleteNote == true ? <DeletePopUp setDeleteNote={setDeleteNote} note={currentNote} index={currentIndex} deleteNote={deleteNote}></DeletePopUp> : ""}

      <div className="main">
        <div className="header">
          <button className="hamburger" onClick={() => setOpen(!open)}>
            ☰
          </button>
          <div className="logo">
            <h1 className="logo-text">{session.user.email}</h1>
            <h1 className="logo-logout" onClick={logOut}>Log out</h1>
          </div>
          <input
            className="title"
            disabled={currentPage == 0 ? true : false}
            value={pageTitle}
            onChange={(e) => {
              setNewTask((prev) => ({ ...prev, title: e.target.value }));
              setPageTitle(e.target.value);
            }}
          ></input>
        </div>

          
        <div className="row">
          <aside className={`sidebar ${open ? "open" : ""}`}>
            <HomePageButton UpdateWorspace={UpdateWorspace}></HomePageButton>
            {Array.from({ length: notes.length }).map((_, i) => (
              <ButtonComponent
                note={notes[i]}
                UpdateWorspace={UpdateWorspace}
                index={i + 1}
                deleteNote={deletePopUp}
              ></ButtonComponent>
            ))}
            <NewNoteButton handleSubmit={addNote}></NewNoteButton>
          </aside>

          <div className="content">
            {currentPage === 0 ? (
              <HomePage></HomePage>
            ) : (
              <textarea
                className="note-area"
                placeholder="Start typing your notes here..."
                value={noteDescription}
                onChange={(e) => {
                  setNewTask((prev) => ({ ...prev, description: e.target.value }));
                  setNoteDescription(e.target.value);
                }}
              ></textarea>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


function DeletePopUp({setDeleteNote, note, index, deleteNote}) {

  return<div className="pop_up">
    
    <div className="delete_popup">

    <h1>Are you sure you want to delete this note?</h1>

    <div className="buttons">
        <div className="confirm" onClick={() => {deleteNote(note,index); setDeleteNote(false)}}>
          <h1>Delete</h1>
        </div>
        <div className="back" onClick={() => setDeleteNote(false)}>
          <h1>Cancel</h1>
        </div>
    </div>
    
    </div>
    
  </div>;

}

function HomePage() {
  return <div className="home_page"></div>;
}

function ButtonComponent({ note, UpdateWorspace, index, deleteNote }) {
  return (
    <div className="tab">
      <button className="tab_button" onClick={(e) => UpdateWorspace(e, index)}>
        {note["title"]}
      </button>
      <div className="circle_icon" onClick={() => deleteNote(note.id, index)}>
        <FaRegTimesCircle className="circle_icon_true"></FaRegTimesCircle>
      </div>
    </div>
  );
}

function HomePageButton({ UpdateWorspace }) {
  return (
    <div className="tab">
      <button className="tab_button_home" onClick={(e) => UpdateWorspace(e, 0)}>
        Home
      </button>
      <FaHome className="home_icon"></FaHome>
    </div>
  );
}

function NewNoteButton({ handleSubmit }) {
  return (
    <div className="tab">
      <div className="circle_icon" onClick={handleSubmit}>
        <FaRegPlusSquare className="circle_icon_true"></FaRegPlusSquare>
      </div>
    </div>
  );
}

export default NotesApp;
